<template>
  <div class="detail-card" data-card-id="image-details">
    <div
      class="card-header"
      :class="{ 'slidein-header': mode === 'draggable' }"
    >
      <div class="header-left">
        <h5 class="card-title">Image Details</h5>
      </div>
      <div class="header-right">
        <button
          class="drag-toggle-btn"
          @click.prevent="$emit('toggleDraggable')"
          :title="mode === 'draggable' ? 'Dock to panel' : 'Make draggable'"
        >
          <font-awesome-icon
            :icon="mode === 'draggable' ? ['fas', 'times'] : ['fas', 'clone']"
          />
        </button>
      </div>
    </div>
    <div class="card-content">
      <div class="detail-item">
        <span class="detail-label">Created on:</span>
        <span class="detail-value">{{
          formatDateTime(submission?.created_at, "yyyy-MM-dd HH:mm") || "N/A"
        }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">Identifier / Name:</span>
        <span class="detail-value">{{ imageName }}</span>
      </div>
      <div class="detail-item" v-if="submission?.patient?.identifier">
        <span class="detail-label">Patient ID:</span>
        <span class="detail-value">{{ submission.patient.identifier }}</span>
      </div>

      <!-- Highlighted Metadata -->
      <div v-if="highlightedMetadataList && highlightedMetadataList.length > 0" class="highlighted-metadata">
        <div
          v-for="(md, index) in highlightedMetadataList"
          :key="'highlighted-' + index"
          class="detail-item"
        >
          <span class="detail-label">{{ md.name }}:</span>
          <span class="detail-value">{{ md.value }}</span>
        </div>
      </div>

      <div v-if="metadata && metadata.length > 0" class="metadata-section">
        <a
          href="#"
          @click.prevent="$emit('toggleMetadata')"
          class="section-toggle"
        >
          <font-awesome-icon
            :icon="
              metadataOpen ? ['fas', 'chevron-down'] : ['fas', 'chevron-right']
            "
            class="me-2"
          />
          <b>Metadata</b>
        </a>
        <div v-if="metadataOpen" class="metadata-list">
          <div
            v-for="(md, index) in metadata.filter((v) => v.value)"
            :key="index"
            class="detail-item"
          >
            <span class="detail-label">{{ md.name }}:</span>
            <span class="detail-value">{{ md.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { formatDateTime } from '@/helpers/project-management/formatters'

const props = defineProps({
  submission: Object,
  metadata: Array,
  metadataOpen: Boolean,
  mode: {
    type: String,
    default: "parked",
  },
  imageName: String,
  project: Object,
});

defineEmits(["toggleDraggable", "toggleMetadata"]);

const highlightedMetadataList = computed(() => {
  if (!props.project?.highlightedMetadata || !props.metadata) return [];
  const highlightedNames = props.project.highlightedMetadata;
  return props.metadata.filter(md => highlightedNames.includes(md.name) && md.value);
});

</script>
